import { p as e, g as be, a as G, _ as x } from "./createTheme-02ce03eb.js";
import * as d from "react";
import { j as M, c as oe } from "./useTheme-efe1290c.js";
import { s as te } from "./styled-38387a7e.js";
import { a as ne, g as me, c as he, u as Ee } from "./useThemeProps-ee4acb93.js";
import { u as Oe } from "./useTheme-d46e2483.js";
import { T as Me, r as we, g as ae } from "./utils-55c3c65e.js";
import { e as X } from "./elementAcceptingRef-ad016689.js";
import { o as $ } from "./ownerDocument-5430cd5b.js";
import { o as re, c as le } from "./ownerWindow-a0b5b7a5.js";
import { e as Ie, P as Ae, H as ye, u as Be } from "./Portal-9153c320.js";
import { u as ce } from "./useEventCallback-fe4fd69c.js";
import { u as de, r as ue, i as je } from "./useSlotProps-5893c531.js";
function De(o) {
  const t = o.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
const Le = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function _e(o) {
  const t = parseInt(o.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? o.contentEditable === "true" || (o.nodeName === "AUDIO" || o.nodeName === "VIDEO" || o.nodeName === "DETAILS") && o.getAttribute("tabindex") === null ? 0 : o.tabIndex : t;
}
function $e(o) {
  if (o.tagName !== "INPUT" || o.type !== "radio" || !o.name)
    return !1;
  const t = (n) => o.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let r = t(`[name="${o.name}"]:checked`);
  return r || (r = t(`[name="${o.name}"]`)), r !== o;
}
function Ue(o) {
  return !(o.disabled || o.tagName === "INPUT" && o.type === "hidden" || $e(o));
}
function He(o) {
  const t = [], r = [];
  return Array.from(o.querySelectorAll(Le)).forEach((n, a) => {
    const s = _e(n);
    s === -1 || !Ue(n) || (s === 0 ? t.push(n) : r.push({
      documentOrder: a,
      tabIndex: s,
      node: n
    }));
  }), r.sort((n, a) => n.tabIndex === a.tabIndex ? n.documentOrder - a.documentOrder : n.tabIndex - a.tabIndex).map((n) => n.node).concat(t);
}
function Ke() {
  return !0;
}
function Y(o) {
  const {
    children: t,
    disableAutoFocus: r = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: a = !1,
    getTabbable: s = He,
    isEnabled: i = Ke,
    open: c
  } = o, p = d.useRef(!1), T = d.useRef(null), R = d.useRef(null), y = d.useRef(null), m = d.useRef(null), k = d.useRef(!1), f = d.useRef(null), w = ne(t.ref, f), P = d.useRef(null);
  d.useEffect(() => {
    !c || !f.current || (k.current = !r);
  }, [r, c]), d.useEffect(() => {
    if (!c || !f.current)
      return;
    const l = $(f.current);
    return f.current.contains(l.activeElement) || (f.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), f.current.setAttribute("tabIndex", "-1")), k.current && f.current.focus()), () => {
      a || (y.current && y.current.focus && (p.current = !0, y.current.focus()), y.current = null);
    };
  }, [c]), d.useEffect(() => {
    if (!c || !f.current)
      return;
    const l = $(f.current), h = (F) => {
      const {
        current: I
      } = f;
      if (I !== null) {
        if (!l.hasFocus() || n || !i() || p.current) {
          p.current = !1;
          return;
        }
        if (!I.contains(l.activeElement)) {
          if (F && m.current !== F.target || l.activeElement !== m.current)
            m.current = null;
          else if (m.current !== null)
            return;
          if (!k.current)
            return;
          let v = [];
          if ((l.activeElement === T.current || l.activeElement === R.current) && (v = s(f.current)), v.length > 0) {
            var j, D;
            const O = !!((j = P.current) != null && j.shiftKey && ((D = P.current) == null ? void 0 : D.key) === "Tab"), A = v[0], u = v[v.length - 1];
            typeof A != "string" && typeof u != "string" && (O ? u.focus() : A.focus());
          } else
            I.focus();
        }
      }
    }, b = (F) => {
      P.current = F, !(n || !i() || F.key !== "Tab") && l.activeElement === f.current && F.shiftKey && (p.current = !0, R.current && R.current.focus());
    };
    l.addEventListener("focusin", h), l.addEventListener("keydown", b, !0);
    const C = setInterval(() => {
      l.activeElement && l.activeElement.tagName === "BODY" && h(null);
    }, 50);
    return () => {
      clearInterval(C), l.removeEventListener("focusin", h), l.removeEventListener("keydown", b, !0);
    };
  }, [r, n, a, i, c, s]);
  const g = (l) => {
    y.current === null && (y.current = l.relatedTarget), k.current = !0, m.current = l.target;
    const h = t.props.onFocus;
    h && h(l);
  }, S = (l) => {
    y.current === null && (y.current = l.relatedTarget), k.current = !0;
  };
  return /* @__PURE__ */ M.jsxs(d.Fragment, {
    children: [/* @__PURE__ */ M.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: S,
      ref: T,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ d.cloneElement(t, {
      ref: w,
      onFocus: g
    }), /* @__PURE__ */ M.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: S,
      ref: R,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Y.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: X,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: e.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: e.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: e.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: e.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: e.func,
  /**
   * If `true`, focus is locked.
   */
  open: e.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Y["propTypes"] = Ie(Y.propTypes));
function qe(o) {
  const t = $(o);
  return t.body === o ? re(o).innerWidth > t.documentElement.clientWidth : o.scrollHeight > o.clientHeight;
}
function W(o, t) {
  t ? o.setAttribute("aria-hidden", "true") : o.removeAttribute("aria-hidden");
}
function pe(o) {
  return parseInt(re(o).getComputedStyle(o).paddingRight, 10) || 0;
}
function We(o) {
  const r = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(o.tagName) !== -1, n = o.tagName === "INPUT" && o.getAttribute("type") === "hidden";
  return r || n;
}
function fe(o, t, r, n, a) {
  const s = [t, r, ...n];
  [].forEach.call(o.children, (i) => {
    const c = s.indexOf(i) === -1, p = !We(i);
    c && p && W(i, a);
  });
}
function ee(o, t) {
  let r = -1;
  return o.some((n, a) => t(n) ? (r = a, !0) : !1), r;
}
function Ve(o, t) {
  const r = [], n = o.container;
  if (!t.disableScrollLock) {
    if (qe(n)) {
      const i = De($(n));
      r.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${pe(n) + i}px`;
      const c = $(n).querySelectorAll(".mui-fixed");
      [].forEach.call(c, (p) => {
        r.push({
          value: p.style.paddingRight,
          property: "padding-right",
          el: p
        }), p.style.paddingRight = `${pe(p) + i}px`;
      });
    }
    let s;
    if (n.parentNode instanceof DocumentFragment)
      s = $(n).body;
    else {
      const i = n.parentElement, c = re(n);
      s = (i == null ? void 0 : i.nodeName) === "HTML" && c.getComputedStyle(i).overflowY === "scroll" ? i : n;
    }
    r.push({
      value: s.style.overflow,
      property: "overflow",
      el: s
    }, {
      value: s.style.overflowX,
      property: "overflow-x",
      el: s
    }, {
      value: s.style.overflowY,
      property: "overflow-y",
      el: s
    }), s.style.overflow = "hidden";
  }
  return () => {
    r.forEach(({
      value: s,
      el: i,
      property: c
    }) => {
      s ? i.style.setProperty(c, s) : i.style.removeProperty(c);
    });
  };
}
function ze(o) {
  const t = [];
  return [].forEach.call(o.children, (r) => {
    r.getAttribute("aria-hidden") === "true" && t.push(r);
  }), t;
}
class Ye {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, r) {
    let n = this.modals.indexOf(t);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(t), t.modalRef && W(t.modalRef, !1);
    const a = ze(r);
    fe(r, t.mount, t.modalRef, a, !0);
    const s = ee(this.containers, (i) => i.container === r);
    return s !== -1 ? (this.containers[s].modals.push(t), n) : (this.containers.push({
      modals: [t],
      container: r,
      restore: null,
      hiddenSiblings: a
    }), n);
  }
  mount(t, r) {
    const n = ee(this.containers, (s) => s.modals.indexOf(t) !== -1), a = this.containers[n];
    a.restore || (a.restore = Ve(a, r));
  }
  remove(t, r = !0) {
    const n = this.modals.indexOf(t);
    if (n === -1)
      return n;
    const a = ee(this.containers, (i) => i.modals.indexOf(t) !== -1), s = this.containers[a];
    if (s.modals.splice(s.modals.indexOf(t), 1), this.modals.splice(n, 1), s.modals.length === 0)
      s.restore && s.restore(), t.modalRef && W(t.modalRef, r), fe(s.container, t.mount, t.modalRef, s.hiddenSiblings, !1), this.containers.splice(a, 1);
    else {
      const i = s.modals[s.modals.length - 1];
      i.modalRef && W(i.modalRef, !1);
    }
    return n;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function Ge(o) {
  return be("MuiModal", o);
}
me("MuiModal", ["root", "hidden", "backdrop"]);
const Xe = ["children", "closeAfterTransition", "component", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "onTransitionEnter", "onTransitionExited", "slotProps", "slots"], Je = (o) => {
  const {
    open: t,
    exited: r
  } = o;
  return he({
    root: ["root", !t && r && "hidden"],
    backdrop: ["backdrop"]
  }, Be(Ge));
};
function Qe(o) {
  return typeof o == "function" ? o() : o;
}
function Ze(o) {
  return o ? o.props.hasOwnProperty("in") : !1;
}
const eo = new Ye(), ge = /* @__PURE__ */ d.forwardRef(function(t, r) {
  var n, a;
  const {
    children: s,
    closeAfterTransition: i = !1,
    component: c,
    container: p,
    disableAutoFocus: T = !1,
    disableEnforceFocus: R = !1,
    disableEscapeKeyDown: y = !1,
    disablePortal: m = !1,
    disableRestoreFocus: k = !1,
    disableScrollLock: f = !1,
    hideBackdrop: w = !1,
    keepMounted: P = !1,
    // private
    manager: g = eo,
    onBackdropClick: S,
    onClose: l,
    onKeyDown: h,
    open: b,
    onTransitionEnter: C,
    onTransitionExited: F,
    slotProps: I = {},
    slots: j = {}
  } = t, D = G(t, Xe), [v, O] = d.useState(!b), A = d.useRef({}), u = d.useRef(null), E = d.useRef(null), B = ne(E, r), _ = Ze(s), L = (n = t["aria-hidden"]) != null ? n : !0, V = () => $(u.current), U = () => (A.current.modalRef = E.current, A.current.mountNode = u.current, A.current), H = () => {
    g.mount(U(), {
      disableScrollLock: f
    }), E.current && (E.current.scrollTop = 0);
  }, K = ce(() => {
    const N = Qe(p) || V().body;
    g.add(U(), N), E.current && H();
  }), J = d.useCallback(() => g.isTopModal(U()), [g]), ve = ce((N) => {
    u.current = N, !(!N || !E.current) && (b && J() ? H() : W(E.current, L));
  }), q = d.useCallback(() => {
    g.remove(U(), L);
  }, [g, L]);
  d.useEffect(() => () => {
    q();
  }, [q]), d.useEffect(() => {
    b ? K() : (!_ || !i) && q();
  }, [b, q, _, i, K]);
  const Q = x({}, t, {
    closeAfterTransition: i,
    disableAutoFocus: T,
    disableEnforceFocus: R,
    disableEscapeKeyDown: y,
    disablePortal: m,
    disableRestoreFocus: k,
    disableScrollLock: f,
    exited: v,
    hideBackdrop: w,
    keepMounted: P
  }), se = Je(Q), Re = () => {
    O(!1), C && C();
  }, Pe = () => {
    O(!0), F && F(), i && q();
  }, Ne = (N) => {
    N.target === N.currentTarget && (S && S(N), l && l(N, "backdropClick"));
  }, Ce = (N) => {
    h && h(N), !(N.key !== "Escape" || !J()) && (y || (N.stopPropagation(), l && l(N, "escapeKeyDown")));
  }, z = {};
  s.props.tabIndex === void 0 && (z.tabIndex = "-1"), _ && (z.onEnter = le(Re, s.props.onEnter), z.onExited = le(Pe, s.props.onExited));
  const ie = (a = c ?? j.root) != null ? a : "div", Fe = de({
    elementType: ie,
    externalSlotProps: I.root,
    externalForwardedProps: D,
    additionalProps: {
      ref: B,
      role: "presentation",
      onKeyDown: Ce
    },
    className: se.root,
    ownerState: Q
  }), Z = j.backdrop, Se = de({
    elementType: Z,
    externalSlotProps: I.backdrop,
    additionalProps: {
      "aria-hidden": !0,
      onClick: Ne,
      open: b
    },
    className: se.backdrop,
    ownerState: Q
  });
  return !P && !b && (!_ || v) ? null : /* @__PURE__ */ M.jsx(
    Ae,
    {
      ref: ve,
      container: p,
      disablePortal: m,
      children: /* @__PURE__ */ M.jsxs(ie, x({}, Fe, {
        children: [!w && Z ? /* @__PURE__ */ M.jsx(Z, x({}, Se)) : null, /* @__PURE__ */ M.jsx(Y, {
          disableEnforceFocus: R,
          disableAutoFocus: T,
          disableRestoreFocus: k,
          isEnabled: J,
          open: b,
          children: /* @__PURE__ */ d.cloneElement(s, z)
        })]
      }))
    }
  );
});
process.env.NODE_ENV !== "production" && (ge.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: X.isRequired,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: e.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: e.oneOfType([ye, e.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: e.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: e.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: e.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: e.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: e.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: e.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: e.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: e.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: e.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: e.func,
  /**
   * @ignore
   */
  onKeyDown: e.func,
  /**
   * If `true`, the component is shown.
   */
  open: e.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: e.shape({
    backdrop: e.oneOfType([e.func, e.object]),
    root: e.oneOfType([e.func, e.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: e.shape({
    backdrop: e.elementType,
    root: e.elementType
  })
});
const oo = ge, to = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], no = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, xe = /* @__PURE__ */ d.forwardRef(function(t, r) {
  const n = Oe(), a = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: s,
    appear: i = !0,
    children: c,
    easing: p,
    in: T,
    onEnter: R,
    onEntered: y,
    onEntering: m,
    onExit: k,
    onExited: f,
    onExiting: w,
    style: P,
    timeout: g = a,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = Me
  } = t, l = G(t, to), h = d.useRef(null), b = ne(h, c.ref, r), C = (u) => (E) => {
    if (u) {
      const B = h.current;
      E === void 0 ? u(B) : u(B, E);
    }
  }, F = C(m), I = C((u, E) => {
    we(u);
    const B = ae({
      style: P,
      timeout: g,
      easing: p
    }, {
      mode: "enter"
    });
    u.style.webkitTransition = n.transitions.create("opacity", B), u.style.transition = n.transitions.create("opacity", B), R && R(u, E);
  }), j = C(y), D = C(w), v = C((u) => {
    const E = ae({
      style: P,
      timeout: g,
      easing: p
    }, {
      mode: "exit"
    });
    u.style.webkitTransition = n.transitions.create("opacity", E), u.style.transition = n.transitions.create("opacity", E), k && k(u);
  }), O = C(f), A = (u) => {
    s && s(h.current, u);
  };
  return /* @__PURE__ */ M.jsx(S, x({
    appear: i,
    in: T,
    nodeRef: h,
    onEnter: I,
    onEntered: j,
    onEntering: F,
    onExit: v,
    onExited: O,
    onExiting: D,
    addEndListener: A,
    timeout: g
  }, l, {
    children: (u, E) => /* @__PURE__ */ d.cloneElement(c, x({
      style: x({
        opacity: 0,
        visibility: u === "exited" && !T ? "hidden" : void 0
      }, no[u], P, c.props.style),
      ref: b
    }, E))
  }));
});
process.env.NODE_ENV !== "production" && (xe.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: e.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: e.bool,
  /**
   * A single child content element.
   */
  children: X.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: e.oneOfType([e.shape({
    enter: e.string,
    exit: e.string
  }), e.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: e.bool,
  /**
   * @ignore
   */
  onEnter: e.func,
  /**
   * @ignore
   */
  onEntered: e.func,
  /**
   * @ignore
   */
  onEntering: e.func,
  /**
   * @ignore
   */
  onExit: e.func,
  /**
   * @ignore
   */
  onExited: e.func,
  /**
   * @ignore
   */
  onExiting: e.func,
  /**
   * @ignore
   */
  style: e.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: e.oneOfType([e.number, e.shape({
    appear: e.number,
    enter: e.number,
    exit: e.number
  })])
});
const ro = xe;
function so(o) {
  return be("MuiBackdrop", o);
}
me("MuiBackdrop", ["root", "invisible"]);
const io = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], ao = (o) => {
  const {
    classes: t,
    invisible: r
  } = o;
  return he({
    root: ["root", r && "invisible"]
  }, so, t);
}, lo = te("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (o, t) => {
    const {
      ownerState: r
    } = o;
    return [t.root, r.invisible && t.invisible];
  }
})(({
  ownerState: o
}) => x({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, o.invisible && {
  backgroundColor: "transparent"
})), Te = /* @__PURE__ */ d.forwardRef(function(t, r) {
  var n, a, s;
  const i = Ee({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: c,
    className: p,
    component: T = "div",
    components: R = {},
    componentsProps: y = {},
    invisible: m = !1,
    open: k,
    slotProps: f = {},
    slots: w = {},
    TransitionComponent: P = ro,
    transitionDuration: g
  } = i, S = G(i, io), l = x({}, i, {
    component: T,
    invisible: m
  }), h = ao(l), b = (n = f.root) != null ? n : y.root;
  return /* @__PURE__ */ M.jsx(P, x({
    in: k,
    timeout: g
  }, S, {
    children: /* @__PURE__ */ M.jsx(lo, x({
      "aria-hidden": !0
    }, b, {
      as: (a = (s = w.root) != null ? s : R.Root) != null ? a : T,
      className: oe(h.root, p, b == null ? void 0 : b.className),
      ownerState: x({}, l, b == null ? void 0 : b.ownerState),
      classes: h,
      ref: r,
      children: c
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Te.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: e.shape({
    Root: e.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: e.shape({
    root: e.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: e.bool,
  /**
   * If `true`, the component is shown.
   */
  open: e.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: e.shape({
    root: e.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: e.shape({
    root: e.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: e.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: e.oneOfType([e.number, e.shape({
    appear: e.number,
    enter: e.number,
    exit: e.number
  })])
});
const co = Te, uo = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "slotProps", "slots", "theme"], po = te("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (o, t) => {
    const {
      ownerState: r
    } = o;
    return [t.root, !r.open && r.exited && t.hidden];
  }
})(({
  theme: o,
  ownerState: t
}) => x({
  position: "fixed",
  zIndex: (o.vars || o).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), fo = te(co, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (o, t) => t.backdrop
})({
  zIndex: -1
}), ke = /* @__PURE__ */ d.forwardRef(function(t, r) {
  var n, a, s, i, c, p;
  const T = Ee({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: R = fo,
    BackdropProps: y,
    classes: m,
    className: k,
    closeAfterTransition: f = !1,
    children: w,
    component: P,
    components: g = {},
    componentsProps: S = {},
    disableAutoFocus: l = !1,
    disableEnforceFocus: h = !1,
    disableEscapeKeyDown: b = !1,
    disablePortal: C = !1,
    disableRestoreFocus: F = !1,
    disableScrollLock: I = !1,
    hideBackdrop: j = !1,
    keepMounted: D = !1,
    slotProps: v,
    slots: O,
    // eslint-disable-next-line react/prop-types
    theme: A
  } = T, u = G(T, uo), [E, B] = d.useState(!0), _ = {
    closeAfterTransition: f,
    disableAutoFocus: l,
    disableEnforceFocus: h,
    disableEscapeKeyDown: b,
    disablePortal: C,
    disableRestoreFocus: F,
    disableScrollLock: I,
    hideBackdrop: j,
    keepMounted: D
  }, L = x({}, T, _, {
    exited: E
  }), V = (n = (a = O == null ? void 0 : O.root) != null ? a : g.Root) != null ? n : po, U = (s = (i = O == null ? void 0 : O.backdrop) != null ? i : g.Backdrop) != null ? s : R, H = (c = v == null ? void 0 : v.root) != null ? c : S.root, K = (p = v == null ? void 0 : v.backdrop) != null ? p : S.backdrop;
  return /* @__PURE__ */ M.jsx(oo, x({
    slots: {
      root: V,
      backdrop: U
    },
    slotProps: {
      root: () => x({}, ue(H, L), !je(V) && {
        as: P,
        theme: A
      }, {
        className: oe(k, H == null ? void 0 : H.className, m == null ? void 0 : m.root, !L.open && L.exited && (m == null ? void 0 : m.hidden))
      }),
      backdrop: () => x({}, y, ue(K, L), {
        className: oe(K == null ? void 0 : K.className, m == null ? void 0 : m.backdrop)
      })
    },
    onTransitionEnter: () => B(!1),
    onTransitionExited: () => B(!0),
    ref: r
  }, u, _, {
    children: w
  }));
});
process.env.NODE_ENV !== "production" && (ke.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: e.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: e.object,
  /**
   * A single child content element.
   */
  children: X.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: e.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: e.shape({
    Backdrop: e.elementType,
    Root: e.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: e.shape({
    backdrop: e.oneOfType([e.func, e.object]),
    root: e.oneOfType([e.func, e.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: e.oneOfType([ye, e.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: e.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: e.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: e.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: e.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: e.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: e.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: e.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: e.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: e.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: e.func,
  /**
   * If `true`, the component is shown.
   */
  open: e.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: e.shape({
    backdrop: e.oneOfType([e.func, e.object]),
    root: e.oneOfType([e.func, e.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: e.shape({
    backdrop: e.elementType,
    root: e.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
});
const No = ke;
export {
  co as B,
  ro as F,
  No as M,
  De as g
};
